import { useCallback, useState } from 'react';
import { Feedback } from '../../types';

type Rates = keyof Feedback;

interface UseRateRecommendation {
  rateRecommendation: (rate: Rates) => void;
  currentRate: Rates | null;
}

const useRateRecommendation = (feedback: Feedback): UseRateRecommendation => {
  const [currentRate, setCurrentRate] = useState<Rates | null>(null);
  const rateRecommendation = useCallback(
    (rate: Rates) => {
      setCurrentRate(rate);
      fetch(feedback[rate]);
    },
    [feedback]
  );

  return {
    rateRecommendation,
    currentRate,
  };
};

export default useRateRecommendation;
